import { SusaninRoute } from '@search/router/src';

export const getDeveloperLink = (props: {
    id: number;
    name: string;
}) => {
    const parts: string[] = [];

    if (props.id !== undefined) parts.push(`zastroyshik-${props.name}-${props.id}`);

    const route = new SusaninRoute({});
    const rec = route.regionParams();

    return `${rec.origin ?? ''}/novostroyki/${parts.length ? `${parts.join('/')}/` : ''}`;
};
